import styled from '@emotion/styled/macro';
import { TableRowWrapper } from '../../../common/SideBySideTableLayout/SideBySideTableLayout.styles';
import Button from '../../../components/Button/Button';
import { FooterButtons } from '../../../components/Table/Table.styles';
import rem from '../../../utils/rem/rem';

export const OptionRecipeInfo = styled.div``;

export const Row = styled.div`
  display: flex;
  gap: 24px;
  margin-top: ${rem(16)};
`;

export const TableRow = styled(TableRowWrapper)`
  border-top: 1px solid ${({ theme }) => theme.colors.gray400};
  padding-top: 32px;
  margin-top: 32px;
  justify-content: space-between;
  gap: ${rem(16)} 32px;
`;

export const SaveButton = styled(Button)`
  position: absolute;
  top: 0;
  right: 0;
`;

export const OptionRecipeForm = styled.div`
  position: relative;
  margin: 0px 32px;

  ${FooterButtons} button {
    margin: 0px;
  }

  ${FooterButtons} {
    padding: ${rem(16)};
    gap: 8px;
    justify-content: flex-start;

    flex-wrap: wrap;
  }
`;
